<!-- 返回按钮 -->
<template>
  <div
    class='back_btn'
    @click="handleBack"
    v-if="showBtn"
  >
    <div class="back_btn_inner">
      <van-icon
        class="back_btn_icon"
        name="arrow-left"
      />
      <span class="bank_btn_text">{{$t('global.back')}}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';
Vue.use(Icon);
export default {
  name: 'BackBtn',
  props: {
    lastPage: {
      type: String,
      default: 'Result'
    }
  },
  data() {
    return {

    };
  },

  computed: {
    pageArr() {
      return [this.$root.firstPage, this.lastPage]
    },
    showBtn() {
      return this.pageArr.indexOf(this.$root.currentPage) == -1
    }
  },

  components: {},

  methods: {
    handleBack() {
      window.history.go(-1)
    }
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.back_btn {
  position: fixed;
  top: 15px;
  left: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  z-index: 15;
  background: rgba(255, 255, 255, 0.65);
  .back_btn_inner {
    display: flex;
    align-items: center;
    .bank_btn_text,
    .back_btn_icon {
      font-size: 14px;
      color: #000;
    }
    .back_btn_icon {
      font-size: 16px;
      margin-right: 2px;
    }
  }
}
</style>